import { Link } from "react-router-dom";

const FOOTER_LINKS = {
  商品: [
    { label: "智慧手機", path: "/shop" },
    { label: "平板電腦", path: "/shop" },
    { label: "筆電", path: "/shop" },
    { label: "音訊設備", path: "/shop" },
    { label: "家電", path: "/shop" },
  ],
  服務: [
    { label: "特色介紹", path: "/features" },
    { label: "聯絡我們", path: "/contact" },
  ],
  關於: [
    { label: "品牌故事", path: "/" },
    { label: "隱私政策", path: "/" },
    { label: "服務條款", path: "/" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#1B4332]">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="block mb-4 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/064db44d-4777-4c03-bf36-b7c201482d38.png"
                alt="Brand Logo"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-white/80 text-sm leading-relaxed">
              精選頂尖 3C 家電，<br />
              極致設計，非凡體驗。
            </p>
          </div>

          {/* Links */}
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white text-sm font-semibold tracking-widest mb-6">
                <a>{title}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-white/70 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-xs">
            © 2026 Premium Store. All rights reserved.
          </p>
          <p className="text-white/60 text-xs">
            曜泰貿易有限公司 &nbsp;|&nbsp; 統一編號：60347163
          </p>
        </div>
      </div>
    </footer>
  );
}
